export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about.jpg" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          {/* <p className="section--title">About</p> */}
          <h1 className="sub--title">About Me</h1>
          <p className="hero--section-description">
            I specialize in building effective software solutions and managing
            projects efficiently. My expertise lies in connecting different
            software components, testing them thoroughly, and overseeing
            projects to success. I'm passionate about learning and using
            technology to solve real-world problems. Collaborating with others
            to achieve remarkable outcomes is what drives me.
            <br />
            <br />
            Besides coding, I enjoy cheering for my favorite soccer team,
            Arsenal, and listening to jazz music. In my spare time, I love to
            play the piano.
          </p>
        </div>
      </div>
    </section>
  );
}
